var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"base-flex__center init-body"},[_c('div',{staticClass:"base-flex__column-center"},[_vm._t("content")],2),_c('div',{staticClass:"init-tips"},[_vm._t("tips")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }